export default __webpack_public_path__ + "static/media/pattern-stripe.dba54962.png";